import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CajaService } from 'app/services/caja.service';
import { ParametrosService } from 'app/services/parametros.service';

@Component({
  selector: 'app-editar-cantidades',
  templateUrl: './editar-cantidades.component.html',
  styleUrls: ['./editar-cantidades.component.css']
})
export class EditarCantidadesComponent implements OnInit {

  verMensaje: boolean;
  form: UntypedFormGroup;
  total: string;
  articulo;
  subtotal: string;
  porcentajeBonificacion;
  indice;
  unArticulo: any;

  constructor(
    public dialogRef: MatDialogRef<EditarCantidadesComponent>,
    private snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    private cajaService: CajaService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.articulo = data.articulo;
      this.porcentajeBonificacion = data.bonificacion;
      this.indice = data.indice;
      this.unArticulo = data.unArticulo;
      this.form = this.fb.group({
        code: [{ value: '', disabled: true }],
        description: [{ value: '', disabled: true }],
        cantidad: [0, [Validators.required, Validators.min(0.01)]],
        preciounitario: [0, [Validators.required, Validators.min(0.01)]],
        subtotal: [{ value: '0', disabled: true }]
      });
      
      // Poblar el formulario con los datos del artículo (formateados a 2 decimales)
      const cantidadFormateada = parseFloat(parseFloat(this.articulo.quantity).toFixed(2));
      const precioFormateado = parseFloat(parseFloat(this.articulo.unitPrice).toFixed(2));
      const subtotalFormateado = parseFloat(parseFloat(this.articulo.subtotal).toFixed(2)).toFixed(2);
      
      this.form.patchValue({
        code: this.articulo.code,
        description: this.articulo.description,
        cantidad: cantidadFormateada,
        preciounitario: precioFormateado,
        subtotal: subtotalFormateado
      });
      
      this.total = Number.parseFloat(this.data.total).toFixed(2);
     }


  ngOnInit(): void {
    // Calcular subtotal inicial
    this.calcularSubtotal();
  }

  calcularPreciosPressKey(e){
    // Permitir teclas de control y números
    const isValidKey = e.key === 'Backspace' || 
                      e.key === 'Delete' || 
                      e.key === 'Tab' || 
                      e.key === 'ArrowLeft' || 
                      e.key === 'ArrowRight' ||
                      e.key === '.' ||
                      (!isNaN(e.key) && e.key !== ' ');

    if (isValidKey) {
      setTimeout(() => {
        this.calcularSubtotal();
      }, 0);
    }
  }

  formatearCantidad() {
    const cantidad = parseFloat(this.form.get('cantidad')?.value) || 0;
    // Redondear a 2 decimales
    const cantidadFormateada = parseFloat(cantidad.toFixed(2));
    this.form.get('cantidad')?.setValue(cantidadFormateada, { emitEvent: false });
    // Recalcular subtotal
    this.calcularSubtotal();
  }

  formatearPrecioUnitario() {
    const precio = parseFloat(this.form.get('preciounitario')?.value) || 0;
    // Redondear a 2 decimales
    const precioFormateado = parseFloat(precio.toFixed(2));
    this.form.get('preciounitario')?.setValue(precioFormateado, { emitEvent: false });
    // Recalcular subtotal
    this.calcularSubtotal();
  }

  calcularSubtotal() {
    const cantidad = parseFloat(this.form.get('cantidad')?.value) || 0;
    const precio = parseFloat(this.form.get('preciounitario')?.value) || 0;
    
    if (cantidad >= 0 && precio >= 0) {
      const cantidadXPrecio = cantidad * precio;
      const bonif = (this.porcentajeBonificacion * cantidadXPrecio) / 100;
      const subtotalCalculado = cantidadXPrecio - bonif;
      
      // Formatear a 2 decimales
      this.subtotal = subtotalCalculado.toFixed(2);
      this.form.get('subtotal')?.setValue(this.subtotal);
    } else {
      this.subtotal = '0.00';
      this.form.get('subtotal')?.setValue(this.subtotal);
    }
  }

  guardar() {
    // Validar que el formulario sea válido
    if (!this.form.valid) {
      this.verMensaje = true;
      return;
    }
    
    // Validar que los valores sean válidos
    const cantidad = parseFloat(this.form.get('cantidad')?.value);
    const precioUnitario = parseFloat(this.form.get('preciounitario')?.value);
    
    if (cantidad <= 0 || precioUnitario <= 0) {
      this.verMensaje = true;
      return;
    }
    
    this.verMensaje = false;
    
    // Actualizar datos en el servicio
    this.cajaService.articulosList[this.indice].quantity = cantidad;
    this.cajaService.articulosList[this.indice].unitPrice = parseFloat(precioUnitario.toFixed(2));
    
    // Calcular subtotal con bonificación
    const cantidadXPrecio = precioUnitario * cantidad;
    const bonif = (this.porcentajeBonificacion * cantidadXPrecio) / 100;
    const subt = cantidadXPrecio - bonif;
    
    // Actualizar subtotales (redondeados a 2 decimales)
    this.cajaService.articulosList[this.indice].subtotalWithIva = parseFloat(subt.toFixed(2));
    this.cajaService.articulosList[this.indice].subtotal = parseFloat(subt.toFixed(2));
    this.cajaService.articulosList[this.indice].bonusAmount = parseFloat(bonif.toFixed(2));
    
    this.snackBar.open('Datos del artículo actualizados correctamente', null, {
      duration: 2000
    });
    this.dialogRef.close(true);
  }

  cancelar() {
    this.dialogRef.close(false);
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, null, {
      duration: 2000
    });
  }

}
